import { View } from "@react-pdf/renderer";
import { ResumePDFText, ResumePDFHighlightableText } from "components/Resume/ResumePDF/common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import { TemplateFivePDFSection, TemplateFivePDFSectionWithSubsections } from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  summary: string;
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateFivePDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      <View wrap={false}>
        {summary && ((enableHighlight || enableMistakeHighlight) ? (
          <ResumePDFHighlightableText
            text={summary}
            section="profile"
            itemIndex={null}
            style={{ lineHeight: "1.3" }}
            enableMistakeHighlight={enableMistakeHighlight}
          />
        ) : (
          <ResumePDFText style={{ lineHeight: "1.3" }}>
            {summary}
          </ResumePDFText>
        ))}
      </View>
    </TemplateFivePDFSectionWithSubsections>
  );
};
